export default "//static.tradera.net/touchweb/static/output/images/visa.339c683d.svg";